import { render, staticRenderFns } from "./OutfitsContent.vue?vue&type=template&id=bfd89c90&scoped=true"
import script from "./OutfitsContent.vue?vue&type=script&lang=js"
export * from "./OutfitsContent.vue?vue&type=script&lang=js"
import style0 from "./OutfitsContent.vue?vue&type=style&index=0&id=bfd89c90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd89c90",
  null
  
)

export default component.exports